<template>
	<div
		:class="[`geo-country__banner__${currentLayout}`]"
		class="geo-country__banner"
	>
		<div class="geo-country__container">
			<p v-html="message" class="geo-country__text"></p>
			<div class="geo-country__buttons__container">
				<div class="geo-country__buttons">
					<slot>
						<button
							class="geo-country__button"
							@click="canShowBottomSheet = true"
						>
							<img
								:src="selectedCountry.imageSrc"
								:alt="selectedCountry.name"
								width="15px"
							/>
							<span style="margin-left: 8px">{{ selectedCountry.name }}</span>
							<svg
								viewBox="0 0 6 4"
								xmlns="http://www.w3.org/2000/svg"
								class="prematch-filter__button__caret"
							>
								<path
									d="M2.87866 3.21484C2.92554 3.28516 2.99585 3.30859 3.07788 3.30859C3.14819 3.30859 3.21851 3.28516 3.2771 3.21484L5.55054 0.941406C5.59741 0.894531 5.63257 0.824219 5.63257 0.742188C5.63257 0.671875 5.59741 0.601562 5.55054 0.542969L5.29272 0.285156C5.23413 0.238281 5.16382 0.203125 5.09351 0.203125C5.01147 0.203125 4.94116 0.226562 4.89429 0.273438L3.07788 2.08984L1.26147 0.273438C1.20288 0.226562 1.13257 0.203125 1.06226 0.203125C0.980225 0.203125 0.909912 0.238281 0.863037 0.285156L0.605225 0.542969C0.546631 0.601562 0.523193 0.671875 0.523193 0.742188C0.523193 0.824219 0.546631 0.894531 0.605225 0.941406L2.87866 3.21484Z"
								></path>
							</svg>
						</button>
					</slot>
					<!-- <button class="geo-country__gobutton">GO</button> -->
				</div>
				<div>
					<button @click="$emit('close-banner')" class="geo-country__cancel">
						Cancel
					</button>
				</div>
			</div>
		</div>
		<!-- <bottom-sheet></bottom-sheet> -->
		<bottom-sheet
			:ref="'bottomSheet'"
			v-if="canShowBottomSheet"
			@close="closeBottomSheet"
			@has-mounted="showBottomSheet"
		>
			<div class="country-choice__container">
				<h2>{{$t('general.switch-country')}}</h2>
				<div
					:class="[chosenCountryCode == country.code ? 'selected' : '']"
					class="country-choice__list"
					v-for="country in env.availableCountries"
					:key="country.code"
					@click="updateSelectedCountry(country)"
				>
					<div class="country-choice__left">
						<img :src="country.imageSrc" :alt="country.name" width="25px" />
						<span class="country-choice__name">{{ country.name }}</span>
					</div>
					<div class="country-choice__right">
						<input
							class="country-choice__checkbox"
							type="checkbox"
							:checked="chosenCountryCode == country.code ? true : false"
						/>
						<span class="country-choice__checkmark"></span>
					</div>
				</div>
				<button @click="confirmCountry" class="country-choice__button">
					{{$t('general.proceed')}}
				</button>
			</div>
		</bottom-sheet>
	</div>
</template>

<script>
export default {
	name: "geo-country-banner",
	props: ["message", "selectedCountryCode"],
	data() {
		return {
			showGeoBanner: false,
			chosenCountryCode: "",
			canShowBottomSheet: false,
		};
	},
	mounted() {
		this.chosenCountryCode = this.selectedCountryCode;
	},
	computed: {
		currentLayout() {
			return this.$store.getters.layout.toLowerCase();
		},
		selectedCountry() {
			let vm = this;
			if (vm.selectedCountryCode == null) return {};
			return vm.env.availableCountries.find((country) => {
				return country.code == vm.selectedCountryCode;
			});
		},
	},
	methods: {
		confirmCountry() {
			let vm = this;
			let chosenCountry = vm.env.availableCountries.find((country) => {
				return country.code == vm.chosenCountryCode;
			});
			localStorage.clear();
			localStorage.countryCode = JSON.stringify(vm.chosenCountryCode);
			vm.$cookie.set("btk-browse-country", vm.chosenCountryCode, 365);
			let localeToSave = chosenCountry.defaultPath.split("/")[1];
			vm.$cookie.set("btk-lang-cn", localeToSave, 10 * 365);
			window.location.href = `${vm.env.desktopUrl}${chosenCountry.defaultPath}`;
		},
		updateSelectedCountry(country) {
			let vm = this;
			vm.chosenCountryCode = country.code;
		},
		showBottomSheet() {
			let vm = this;
			this.canShowBottomSheet = true;
			this.$nextTick(() => {
				this.$refs.bottomSheet.setState("open");
			});
		},
		closeBottomSheet() {
			this.$refs.bottomSheet.setState("close");
			this.$nextTick(() => {
				this.canShowBottomSheet = false;
			});
		},
	},
};
</script>

<style lang="scss">
.geo-country {
	&__banner {
		width: 100%;
		// border-top: 0.25px solid var(--light-black);
		padding-right: 10px;
		position: fixed;
		// background: var(--light-gray);
		z-index: 10000;
		display: flex;
		align-items: center;
		justify-content: center;
		&__mobile {
			bottom: 48px;
			height: 165px;
		}
		&__desktop {
			bottom: 0px;
			// height: 120px;
		}
	}
	&__container {
		bottom: 0;
		margin: 0 auto;
		background: #e1e8ed;
		color: var(--blue-gray);
		max-width: 1200px;
		border-radius: 5px;
	}
	&__buttons {
		display: flex;
		margin-bottom: 15px;
		&__container {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
		}
	}
	&__button {
		font-size: var(--font-medium);
		border: none;
		background: var(--white);
		color: var(--black);
		border-radius: 25px;
		padding: 10px 15px;
		white-space: nowrap;
		display: flex;
		flex-direction: row;
		align-items: center;
		margin-left: 5px;
	}
	&__cancel {
		background: transparent;
		border: none;
		padding-bottom: 15px;
		color: var(--blue-gray);
	}
	&__gobutton {
		background: var(--green);
		color: var(--black);
		border-radius: 50%;
		border: none;
	}
	&__text {
		text-align: center;
		// color: var(--light-black);
		color: var(--blue-gray);
		font: var(--font-small);
		padding: 0 10px;
	}
}
</style>
